import styled from 'styled-components';
import {
    PrimaryButtonComponent, DisplayFlex
} from "../../../../../../CommonComponents/commonStyles";
import { InfoContentWrapper } from '../../../../../TransactionSummary/Components/DateTimepicker/styles';

export const QASection = styled.div``;

export const InfoContentWrappered = styled(InfoContentWrapper)`
  height : 470px;
  
`;

export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
  width: 150px;
  border-radius: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: 16px;
  letter-spacing: 0.5px;
  cursor: pointer;
  border: none;
  z-index: 1000; 
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  padding-top: 100px;
  
`;

export const DisplayFlexOkay = styled(DisplayFlex)`
  justify-content: center;
  align-items: center;
  height: 18.6%;
    border-radius: 0 0 4px 4px;
    padding: 30px 16px;
    padding-top: 0px;
`;

export const PopHeader = styled.div`
  font-family: BerkeleyStd-Bold;
  font-size: 24px;
  color: #022737;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
   @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 20px;
  }
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 0 0;
`;

export const IconWrap = styled.div`
  float: right;
  cursor: pointer;
  margin-top: 23px;
  margin-right: -40px;

  @media only screen and (min-width: 426px) and (max-width: 768px) {
    margin-right: -29px
    }

  i {
    font-size: 20px;
    color: #1d1d1b;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: 0;
  }

  @media only screen and (min-width: 2560px) {
    margin-right: -97px;
  }

`;

export const CalenderClear = styled.span`
  cursor: pointer;
  padding-right: 5px;
  padding-left: 3px;
`;